/**************************************
 * Created By LinK On 2020/2/11 22:05.
 **************************************/
export var ID = '@antAliPay';
export default {
    ID: ID
};
